import React, {useState} from "react";
import {projectStatusDisplayMap} from "../ProjectStatusMap";
import { Col, Grid, Row } from 'react-flexbox-grid';
import {unMergeProject} from "../../api/MergeUnMerge";
import SpinnerNew from "../Spinner/SpinnerNew";
import {Button, Card, Checkbox, Radio} from 'antd';
import {getToolTipFormatedStrB} from "../Utils/String";

function UnMergeDialog({ project, onUnMerge, onClose}) {

    const [mergeFlag,setMergeFlag] = useState(0);
    const [mergeDisabled, setMergeDisabled] = useState(true);
    const [checkCount, setCheckCount] = useState(0);
    const [selectedList] = useState([]);
    const [unMergeStarted, setUnMergeStarted] = useState(false);
    const [selectedStations] = useState([]);

    function onCheckBoxClick(e, p)
    {
        //console.log('selectedList   0',selectedList);
        let val = checkCount;
        if (e.target.checked === true)
        {
            val = val + 1;
            setCheckCount(val);
            selectedList.push(p.id);
            selectedStations.push(p.stationName);
        }
        else
        {
            const index1 = selectedStations.indexOf(p.stationName);
            if (index1 > -1) {
                selectedStations.splice(index1, 1);
            }
            const index = selectedList.indexOf(p.id);
            if (index > -1) {
                selectedList.splice(index, 1);
            }
            val = val - 1;
            setCheckCount(val);
        }
        let cnt = selectedStations.filter((value, index, self) => self.indexOf(value) === index).length;
        //console.log('selectedList   1',selectedList);
        setMergeDisabled(val < 2 || val === project.relatedProjects.length ? true : false || cnt > 1);
        if(val < 2 || val === project.relatedProjects.length || cnt > 1) setMergeFlag(0);
    }

    function onMergeClick(e)
    {
        //console.log('merge......',e);
        setMergeFlag(e.target.value)
    }

    return (
        <Card
            style={{width:'600px'}}
            title={"UnMerge Projects?"}
             actions={[<Button
                id={'yesUnMergeBtn'}
                type={"link"}
                style={{height: 'auto'}}
                disabled={checkCount < 1 || unMergeStarted}
                onClick={async () => {
                    // call unmerge
                    let unMergeRequest = {
                        'projectId': project.id,
                        'mergeFlag': mergeFlag===1 ? 'Y' : 'N',
                        'selectedList': selectedList
                    };
                    //console.log('unMergeRequest', unMergeRequest);
                    setUnMergeStarted(true);
                    let response = await unMergeProject(project.id, unMergeRequest);
                    onClose();
                    onUnMerge(response);
                }}
            >
                Yes, UnMerge
            </Button>,
                <Button
                    type={"link"}
                    style={{height: 'auto'}}
                    disabled={unMergeStarted}
                    onClick={async () => {
                        onClose();
                    }}
                >
                    No, Keep Merged
                </Button>]}
            headStyle={{fontWeight: 700, fontSize: "20px"}}
        >
            <SpinnerNew display={unMergeStarted}/>
            <div>The following <b>{projectStatusDisplayMap[project.projectStatus]}</b> projects from <b>{project.stationName}</b> are Merged.
                Which Projects would you like to UnMerge?<br/>
                UnMerged projects will end in the same status as they began, unless the separate project(s) have 0 assets,
                in which case they will land in the In-Development status.</div>
            <hr/>
            <Grid style={{maxHeight:'400px', overflowY:'scroll'}}>
                {project.relatedProjects.map((p,index) => (
                    <>
                        <Row>
                            <Col lg={1} md={1} xs={1}>
                                <Checkbox id={'checkbox'+p.bpid} onClick={(e) => onCheckBoxClick(e,p)} disabled={unMergeStarted}/>
                            </Col>
                            <Col lg={10} md={10} xs={10}>
                                <div><b>{'Project Description:'}</b> {p.projectDescription}</div>
                                <div><b>{'Construction Start Date:'}</b> {p.constructionStartDate}</div>
                                <div><b>{'In Service Date:'}</b> {p.inServiceDate}</div>
                                <div>{getToolTipFormatedStrB('WO',p.workOrder)}</div>
                                <div><b>{'BPID:'}</b> {p.bpid}</div>
                                <div><b>{'MPID:'}</b> {p.mpid}</div>
                                <br/>
                                <div>Total of {p.noOfAssets} Assets</div>
                                <div>Total of {p.noOfSectionAssets} Assets Assigned Section(s)</div>
                                <div>Total of {p.noOfFormAssets} Assets Assigned to Pre-E Form(s)</div>
                            </Col>
                        </Row>
                        {index < (project.relatedProjects.length-1) ? <hr/> : ''}
                    </>
                ))}
            </Grid>
            <hr/>
            <div>
                <Row style={{justifyContent:'center'}}>
                    <Col>
                        <div style={{marginLeft:20, marginRight:20}}>For the items selected, would you like 1 combined Checklist with<br/> multiple BPIDs or
                            separate checklists for each BPID?</div>
                    </Col>
                </Row>
                <Row style={{justifyContent:'center'}}>
                    <Col>
                        <Radio.Group style={{display: 'inline-flex'}} id={'merge-check'}
                                     options={[{
                                         label: 'Combined',
                                         value: 1
                                     }, {label: 'Separated', value: 0}]}
                                     disabled={mergeDisabled}
                                     onChange={(e) => onMergeClick(e)}
                                     value={mergeFlag}/>
                    </Col>
                </Row>
            </div>
        </Card>
    )
}

export default UnMergeDialog;
